import React, { useRef } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import OtpInput from "../OtpInput";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import rightTick from "../../../asset/images/rightTick-Circle.svg";
import {
  AESEncryption,
  ApiResDecrypt,
  mobileNumberEnc,
  mobileVal,
} from "../../../CommonMethhods/CommonMethods";
import axios from "axios";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { useEffect } from "react";
import SmallLoader from "../../../Components/Common/smallLoader";

function NonIndividualAccountDetails(props) {
    return (
        <div className="overview-card-sec">
          {/* <form onSubmit={handleSubmit(onFinalSubmit)}> */}
          <div className="card-box">
        <div className="over-inside-wrapper">
          <label className="input-title">Non-Individual’s Accounts</label>
          <div className="card-indi">
            <ul>
              <li className="opened-section">
                <span className="sec-title">Accounts Opened</span>
                <span className="sec-value">20,000</span>
              </li>
              <li className="pending-section">
                <span className="sec-title">Pending Accounts</span>
                <span className="sec-value">3,098</span>
              </li>
              <li className="total-section">
                <span className="sec-title">Total Accounts</span>
                <span className="sec-value">23,098</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
          {/* </form> */}
        </div>
      );
}

export default NonIndividualAccountDetails;
